import { render, staticRenderFns } from "./MerchantTotalUpfrontStatistics.vue?vue&type=template&id=5495dac3&"
import script from "./MerchantTotalUpfrontStatistics.vue?vue&type=script&lang=ts&"
export * from "./MerchantTotalUpfrontStatistics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MerchantTotalUpfrontStatistics.vue"
export default component.exports